import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  container: {
    backgroundColor: theme.palette.whitePepper.main,
  },
  heading: {
    margin: '20px 0',
  },
});
